<template>
    <b-card title="Metódos de Pagamento">
        <b-overlay :show="loading">

            <div class="row mb-3">
                <div class="col d-flex gap-2 overflow-auto">
                    <div class="w-100" v-if="data.length === 0">
                        Nenhum Método de pagamento encontrado.
                    </div>
                    <div v-for="method in data" :key="method.id" class="card-shape p-3 bg-primary text-white d-flex flex-1 flex-column justify-content-between font-weight-bolder" style="background-color: #dedede;">
                        
                        <div class="text-capitalize d-flex justify-content-between align-items-start">
                            <div>
                                {{ method.card.brand }}
                                <span v-if="method.id === defaultPaymentMethod" class="ml-1 badge badge-light badge-sm">Padrão</span>
                            </div>
                            <div>
                                <b-dropdown size="sm" text="small" variant="primary" toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
                                          </svg>
                                    </template>
                                    <b-dropdown-item-button @click="changeDefault(method.id)" v-if="method.id != defaultPaymentMethod">Tornar Padrão</b-dropdown-item-button>
                                    <b-dropdown-item-button @click="remove(method.id)">Remover</b-dropdown-item-button>
                                </b-dropdown>
                            </div>
                        </div>
                        <div class="h3">
                           <span>**** **** ****</span> {{ method.card.last4 }}
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                {{ method.billing_details.name }}
                            </div>
                            <div>
    
                                {{ method.card.exp_month }}/{{ method.card.exp_year }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
        <button class="btn btn-primary" v-b-modal.create-method>Adicionar Método</button>
        <b-modal title="Adicionar Novo Método" id="create-method" hide-footer>
            <Form />
        </b-modal>
    </b-card>
</template>

<script>
import Form from './card/Form.vue';
export default {
    components: {
        Form
    },
    props: {
        data: {
            type: Array,
            default: [],
        },

        defaultPaymentMethod: {
            type: String | null,
            default: '',
        }
    },
    data () {
        return {
            loading: false,
        }
    },
    methods: {
        changeDefault(payment_method_id){
            this.loading = true
            axios.post('/teacher/subscription/payment-method/default', {
                payment_method_id: payment_method_id
            }).then((result) => {
                window.location.reload()
            }).catch((err) => {
                
            }).finally(()=> this.loading = false);
        },

        remove(payment_method_id){
            this.loading = true
            axios.post('/teacher/subscription/payment-method/remove', {
                payment_method_id: payment_method_id
            }).then((result) => {
                window.location.reload()
            }).catch((err) => {
                
            }).finally(()=> this.loading = false);
        }
    }
}
</script>

<style>
    .card-shape{
        width: 275px;
        min-width: 275px;
        height: 172px;
        min-height: 172px;
        border-radius: 10px;
    }
</style>